import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconMenu = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" }, void 0) }, void 0));
const Memo = memo(SvgIconMenu);
export default Memo;
//# sourceMappingURL=IconMenu.js.map